// Aparat widzi ten sam kod w kilkunastu klatkach na sekundę. Bez odsiewu jedna naklejka
// przytrzymana przed obiektywem dodawałaby sztukę do rezerwacji kilkanaście razy.
//
// Okno jest ODŚWIEŻANE, dopóki ten sam kod jest w kadrze: kod wraca dopiero wtedy, gdy zniknie
// z obiektywu na `windowMs`. Stałe okno od pierwszego odczytu przepuszczałoby go ponownie co dwie
// sekundy przy naklejce trzymanej nieruchomo — dokładnie wtedy, gdy człowiek czyta komunikat.
export function createScanDeduper(windowMs = 2000) {
  let last = null;
  let lastAt = -Infinity;
  return function accept(code, now) {
    const c = String(code == null ? '' : code).trim();
    if (!c) return false;
    if (c === last && now - lastAt < windowMs) {
      lastAt = now;
      return false;
    }
    last = c;
    lastAt = now;
    return true;
  };
}
